<script lang="ts">
  import type { PortableTextBlock } from "@portabletext/types";
  // import PortableTextContent from "$lib/portableText/PortableTextContent.svelte";
  import { PortableText } from "@portabletext/svelte";
  import { contentBlockComponents } from "./portableText/utils";

  interface Props {
    title?: string | null;
    content: PortableTextBlock[];
    center?: boolean;
    bookStyle?: boolean;
    children?: import("svelte").Snippet;
    below?: import("svelte").Snippet;
  }

  let {
    title = null,
    content,
    center = false,
    bookStyle = false,
    children,
    below,
  }: Props = $props();
</script>

<article class:center class:book-style={bookStyle}>
  {#if title}
    <h1 class="px-edge-x max-w-prose-edge-x">{title}</h1>
  {/if}

  {@render children?.()}

  <!-- <PortableTextContent {content} --line-height="1.5" /> -->

  {#if content?.length}
    <div class="contents">
      <span
        class="pre-content siblings-prose siblings-w-prose-edge-x siblings-max-w-full siblings-px-edge-x siblings-leading-normal"
      ></span>

      <PortableText
        value={content}
        onMissingComponent={false}
        components={contentBlockComponents}
      />
    </div>
  {/if}

  {@render below?.()}
</article>

<style lang="postcss">
  article :global(:where(h2, * h2)),
  article :global(:where(h3, * h3)) {
    margin-block-start: var(--s-8);
  }

  article :global(:where(.image-component-container)) {
    margin-block: var(--s-6);
  }

  /* Center variant */

  article.center h1,
  article.center :global(.pre-content ~ *) {
    margin-inline: auto;
  }

  /* Book style variant */

  .book-style :global(.pre-content ~ p),
  .book-style :global(.pre-content ~ * p) {
    margin-block-end: 0;
  }

  .book-style :global(.pre-content ~ p + p),
  .book-style :global(.pre-content ~ * p + p) {
    margin-block-start: 0;
    text-indent: var(--space-inline);
  }

  /* Pre-content */

  /* line-height */
  .pre-content ~ :global(*) {
    line-height: 1.5;
  }

  /* lists */
  .pre-content ~ :global(* li) {
    margin-block: var(--s-1);
  }

  .pre-content ~ :global(:where(ol, ul) :where(ol, ul)) {
    margin-block: 0;
  }

  .pre-content ~ :global(ol) {
    list-style: inside decimal;
  }

  .pre-content ~ :global(ul) {
    list-style: inside disc;
  }

  .pre-content ~ :global(:where(ol, ul) ol) {
    padding-inline-start: var(--space-inline);
    list-style: decimal;
  }

  .pre-content ~ :global(:where(ol, ul) ul) {
    padding-inline-start: var(--space-inline);
    list-style: disc;
  }

  @media (--laptop) {
    .pre-content ~ :global(ol) {
      list-style: decimal;
    }
    .pre-content ~ :global(ul) {
      list-style: disc;
    }
  }
</style>
